import React, { Component } from 'react'
import styled from 'styled-components'
import { defaultTheme } from '../../styles/themes'
import Icons from '../../components/ui/Icons'
import { formataCnpj } from '../../../utils/formataCnpj'

const TdTitulo = styled.td`
  color: #767676;
  font-weight: 600;
`

const TdIcons = styled.td`
  color: #767676;
  width: 40px;
  text-align: right;
  cursor: pointer;
`

const Tabela = styled.table`
  font-family: ${defaultTheme.fonts.primary};
  border-bottom: 1px solid #c3c3c3;
  font-size: 14px;
  width: 100%;
  color: #a5a5a5;
  td {
    border-bottom: 1px solid #c3c3c3;
    vertical-align:middle;
    padding: 10px 2px;
    @media(max-width: 1024px) {
     padding: 5px 5px;
    }
  }`

class TabelaEmpresa extends Component {
  constructor () {
    super()
    this.state = {
    }
  }

  render () {
    const listaFiliais = this.props.dados[0]
    const dados = listaFiliais && listaFiliais.branchOffices
    return (
      <Tabela>
        <tbody>
          <tr>
            <TdTitulo style={{width:  '350px'}}>Empresa</TdTitulo>
            <TdTitulo>Razão Social</TdTitulo>
            <TdTitulo>CNPJ</TdTitulo>
            <TdIcons></TdIcons>
            <TdIcons></TdIcons>
          </tr>
          {dados && dados.map((item) => {
            return <tr key={item.id}>
              <td>{item.profile.given_name}</td>
              <td>{item.profile.full_name}</td>
              <td>{formataCnpj(item.profile.document)}</td>
              <td></td>
              <TdIcons>
                <span>
                  <Icons
                    onClick={() => this.props.edicao(item)}
                    icon={'pencil'}
                    color={'#767676'}
                    width={16}
                    height={16} />
                </span>
              </TdIcons>
              {/* <TdIcons>
                <span >
                  <Icons
                    onClick={() => alert('Excluído com sucesso!')}
                    icon={'trash'}
                    color={'#767676'}
                    width={16}
                    height={16} />
                </span>
              </TdIcons> */}
            </tr>
          })
          }
        </tbody>
      </Tabela>
    )
  }
}

export default TabelaEmpresa
